export const enum FileModeEnum {
  ALL = 'All',
  IMAGES_ONLY = 'ImagesOnly',
  IMAGES_EXCLUDED = 'ImagesExcluded',
}
